import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../../../../utilities/requestClient';

export type TriumMonthlyReportUsers = {
  [key: string]: string[];
};

export function useTriumMonthlyReportUsers() {
  return useQuery({
    queryKey: ['trium-monthly-report-users'],
    queryFn: () => getTriumMonthlyReportUsers(),
  });
}

export const getTriumMonthlyReportUsers = async (): Promise<TriumMonthlyReportUsers> => {
  const response = await AxiosInstance.get('/trium_monthly_report_users');
  return response.data;
};

